const rootEnv =
  window.LUCID_SPA_CONFIG || ({} as Partial<Window['LUCID_SPA_CONFIG']>);

export const AUTH0_DOMAIN = rootEnv.REACT_APP_AUTH0_DOMAIN || '';

export const AUTH0_CLIENT_ID = rootEnv.REACT_APP_AUTH0_CLIENT_ID || '';

export const AUTH0_CALLBACK =
  rootEnv.REACT_APP_AUTH0_CALLBACK || window.location.origin;

export const AUTH0_AUDIENCE = 'https://api.luc.id';
